import React,{Component} from "react";
import "./Customer.css";
class Customer extends Component{
    render(){
        return(
                <>
                <h1
          style={{ textAlign: "center", marginTop: "100px", fontSize: "100px" }}
        >
          Customer Support
        </h1>
        <h2
          style={{ textAlign: "center", marginTop: "80px", fontSize: "60px" }}
        >
          We're here to help.
        </h2>
        <h3
          style={{ textAlign: "center", marginTop: "60px", fontSize: "30px" }}
        >
          Have an issue with an order or feedback for us? Our support team is here to help you.
        </h3>

        <div className="first-dv">
            <div>
            <h3>Order Related Queries</h3>
            <hr />
            <p>Connect with the customer support on the app</p>
              </div>
              <div>
              <h3>For Anything Else</h3>
              <hr />
              <p>Send us an Email to support@gims.com</p>
              </div>
        </div>
                </>
        );
    }
}
export default Customer;